import type { Session } from "../lib/auth";
import { emptyRoom, newProject, type Project, type RoomDraft, SHAPES } from "./model";
import { getProject, saveProject, updateProject } from "./store";
import { nth } from "../lib/at";

export interface DealSeed {
  id: string;
  title: string;
  site_address: string | null;
  contact: { name: string; phone: string | null } | null;
}

export async function createProject(session: Session, deal?: DealSeed): Promise<Project> {
  const p = newProject(crypto.randomUUID(), session.user.display_name, new Date().toISOString(), {
    org_id: session.active_org_id ?? "",
    user_id: session.user.id,
  });
  if (deal) {
    p.deal_id = deal.id;
    p.deal_title = deal.title;
    p.title = deal.title;
    p.site.address = deal.site_address ?? "";
    p.site.customer_name = deal.contact?.name ?? "";
    p.site.customer_phone = deal.contact?.phone ?? "";
  }
  await saveProject(p);
  return p;
}

export async function addRoom(projectId: string, shapeKey: string, name: string): Promise<RoomDraft> {
  const shape = SHAPES.find((s) => s.key === shapeKey) ?? nth(SHAPES, 0);
  let room: RoomDraft | undefined;
  await updateProject(projectId, (p) => {
    const used = new Set(p.rooms.map((r) => r.id));
    let i = p.rooms.length + 1;
    while (used.has(`R${i}`)) i += 1;
    room = emptyRoom(`R${i}`, name, shape.sketch.map(([x, y]) => [x, y]));
    p.rooms.push(room);
  });
  if (!room) throw new Error(`project ${projectId} not found`);
  return room;
}

export function projectTitle(p: Project): string {
  return p.title || p.site.customer_name || p.site.address || "Нэргүй төсөл";
}

export function exists(id: string): boolean {
  return Boolean(getProject(id));
}
